import createIcon from '../../createIcon';

/**
 * @component @name Umbrella
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSA3LjQyTDEzIDYuMjdWMy45QzEzIDMuNjQgMTMuMjIgMy40MiAxMy41IDMuNDJDMTMuNzggMy40MiAxNCAzLjYzIDE0IDMuOVY0LjVIMTZWMy45QzE2IDIuNTcgMTQuODggMS41IDEzLjUgMS41QzEyLjEyIDEuNSAxMSAyLjU3IDExIDMuOVY2LjI3TDkuNSA3LjQyTDYgNi41N0wxMS4wNSAyMS44MkMxMS4yIDIyLjI3IDExLjYgMjIuNSAxMiAyMi41QzEyLjQgMjIuNSAxMi44IDIyLjI3IDEyLjk1IDIxLjgxTDE4IDYuNTdMMTQuNSA3LjQyWk0xMy4yOCA5TDE0LjA0IDkuNThMMTQuOTYgOS4zNUwxMyAxNS4zVjguNzlMMTMuMjggOVpNOS45NiA5LjU5TDEwLjcyIDkuMDFMMTEgOC43OVYxNS4zTDkuMDMgOS4zNkw5Ljk2IDkuNTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Umbrella = createIcon('Umbrella', [
  [
    'path',
    {
      d: 'M14.5 7.42L13 6.27V3.9C13 3.64 13.22 3.42 13.5 3.42C13.78 3.42 14 3.63 14 3.9V4.5H16V3.9C16 2.57 14.88 1.5 13.5 1.5C12.12 1.5 11 2.57 11 3.9V6.27L9.5 7.42L6 6.57L11.05 21.82C11.2 22.27 11.6 22.5 12 22.5C12.4 22.5 12.8 22.27 12.95 21.81L18 6.57L14.5 7.42ZM13.28 9L14.04 9.58L14.96 9.35L13 15.3V8.79L13.28 9ZM9.96 9.59L10.72 9.01L11 8.79V15.3L9.03 9.36L9.96 9.59Z',
      key: 'sbylm3',
    },
  ],
]);

export default Umbrella;
